import React,{useEffect,useState,useContext} from 'react'
import Loading from '../../components/Loading/index.js'
import EmptyList from '../../components/EmptyList/index.js'
import LoadingFailed from '../../components/LoadingFailed/index.js'
import axios from 'axios'
import {Container} from 'react-bootstrap'
import {IconContext} from 'react-icons'
import {HiTemplate} from 'react-icons/hi'
import { v4 as uuidv4 } from 'uuid';
import PrefixContext from '../../context/PrefixContext.js'

function Index() {

    const PrefixContextData = useContext(PrefixContext);
    const [templates, settemplates] = useState()
    const [loading, setloading] = useState('LOADING')

    const getTemplates = () => {
        axios.get(PrefixContextData.prefixUrl+'data/templates')
            .then(response => {
                if(response.status === 200){
                    setloading('LOADED');
                    settemplates(response.data);
                }
                else{
                    setloading('FAILED');
                    console.log('Resume Data Loading Failed')
                }
            })
            .catch(error => {
                setloading('FAILED');
                console.log('Resume Data Loading Failed')
            });
    }


    useEffect(() => {
        getTemplates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
        <>
            {loading === 'LOADING' && <Loading type="withImage"/>}
            {
                <section className="page-heading-margin bg-secondary">
                    <Container>
                        <h5 className="mt-3 mt-md-3">
                            <IconContext.Provider value={{ color: "white", className: "global-class-name" }}>
                                <div className="bg-primary d-inline-block p-2 mx-2 rounded">
                                    <HiTemplate />
                                </div>
                            </IconContext.Provider>
                        &nbsp;&nbsp;Our templates
                        </h5>
                        {loading === 'FAILED' && <LoadingFailed/>}
                        <div className="d-flex flex-wrap pt-3 pt-md-3">
                            {(loading === 'LOADED' && templates !== undefined && templates.length !== 0) ? <>
                                {templates.map((el)=>{
                                    return <div key={uuidv4()} className="d-flex flex-column mx-auto m-md-0 pb-5">
                                            <img style={{width:"200px",marginRight:"50px",paddingBottom:"10px"}} src={el.image} alt=""/>
                                            <p>{el.name}</p>
                                        </div>
                                })}
                            </> : <EmptyList />}
                        </div>
                    </Container>
                </section>
            }

        </>
    )
}

export default Index
